import { useCallback, useEffect } from 'react';

export const useAudio = (url) => {

  // 1. PRELOAD (Rozgrzewka) 🔥
  // To się odpala raz, jak tylko user wejdzie na stronę.
  // Pobiera plik do cache przeglądarki, ale go nie gra.
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const preloadAudio = new Audio(url);
      preloadAudio.preload = "auto"; // Wymuś pobranie
      preloadAudio.load();           // Wykonaj
      // Nie robimy play(), więc nie ma widżetu
    }
  }, [url]);

  const play = useCallback(() => {
    if (typeof window === 'undefined') return;
    if (localStorage.getItem('sound_enabled') === 'false') return;

    // 2. ODTWARZANIE (Z Cache'u) ⚡
    // Tworzymy nową instancję, ale przeglądarka weźmie dane z cache (0ms network lag)
    const audio = new Audio(url);
    
    // Opcjonalnie: hack na szybsze odtwarzanie na iOS (low latency)
    // audio.preload = "auto"; 

    // 3. SPRZĄTANIE (Zabijanie Zombie) 🧟‍♂️
    audio.onended = () => {
      audio.pause();
      audio.currentTime = 0;
      audio.src = "";       // To usuwa widżet
      audio.remove();
    };

    // Obsługa błędów
    const playPromise = audio.play();
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        // console.debug("Audio play blocked", error);
      });
    }

  }, [url]);

  return play;
};